import React, { useLayoutEffect } from 'react';
import mixpanel from 'mixpanel-browser';
import { MIX_PANEL_CODE, ENV_MODE, MIX_PANEL_ENABLED } from '../../constants';

const useMixPanel = () => {
    function initializedMixPanel() {
        if (MIX_PANEL_CODE && MIX_PANEL_ENABLED === 'TRUE') {
            const mixpanelDebug = ENV_MODE !== 'production';
            mixpanel.init(MIX_PANEL_CODE, {
                debug: mixpanelDebug,
                track_pageview: false,
                persistence: 'localStorage',
            });
        }
    }

    useLayoutEffect(() => {
        initializedMixPanel();
    }, []);
}

export default useMixPanel;